import borderRadius from 'src/theme/core/borderRadius'

const styles = theme => ({
  content: {
    display: 'flex',
    margin: 'auto',
    height: '600px',
    padding: '20px 120px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    alignSelf: 'stretch',
    maxWidth: '800px',
    backgroundImage: `url(/assets/editor-file/free-account/upgrade-popup-star.svg)`,
  },
  button: {
    marginTop: '20px',
  },
  iframe: {
    borderRadius: '16.886px',
  },
  header: {
    color: 'var(--mcg-blue, #015FFB)',
    textAlign: 'center',
    /* Heading/H2 Heading */
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%' /* 36px */,
  },
  text: {
    color: '#637381',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
})

export default styles
